import { render, staticRenderFns } from "./studentEduInfo.vue?vue&type=template&id=4194f290&"
import script from "./studentEduInfo.vue?vue&type=script&lang=ts&"
export * from "./studentEduInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports